<template>
  <div :id="id" :class="className" :style="{ height: height, width: width }" />
</template>
<script>
import echarts from "echarts";
import resize from "./mixins/resize";

export default {
  mixins: [resize],
  props: {
    className: {
      type: String,
      default: "chart",
    },
    id: {
      type: String,
      default: "chart",
    },
    width: {
      type: String,
      default: "100%",
    },
    height: {
      type: String,
      default: "100%",
    },
    chartData: {
      type: Object,
    },
  },
  data() {
    return {
      chart: null,
      options: {
        backgroundColor: "rgba(128, 128, 128,0)",
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "shadow",
            textStyle: {
              color: "#fff",
            },
          },
        },
        grid: {
          top: "15%",
          borderWidth: 0,
          bottom: "0",
          left: "15%",
          textStyle: {
            color: "#fff",
          },
        },
        calculable: true,
        xAxis: [
          {
            type: "category",
            axisLine: {
              show: false,
            },
            axisLabel: {
              show: true,
              margin: "10",
              fontSize: "10",
              rotate: 45,
              textStyle: {
                color: "#ffffff", //X轴文字颜色
              },
            },
            splitLine: {
              show: false,
            },
            axisTick: {
              show: false,
            },
            splitArea: {
              show: false,
            },
            data: [],
          },
        ],
        yAxis: [
          {
            name: "",
            type: "value",
            splitLine: {
              show: false,
            },
            nameTextStyle: {
              color: "#339FFB",
              fontSize: 8,
              show: true,
              lineHeight: 0,
            },
            splitLine: {
              lineStyle: {
                type: "dashed",
                color: "#1B2F44",
              },
            },
            axisLine: {
              show: false,
            },
            axisTick: {
              show: false,
            },
            axisLabel: {
              interval: 0,
              color: "#AEB7C0",
              fontSize: 12,
            },
            splitArea: {
              show: false,
            },
          },
        ],
        series: [
          {
            name: "",
            type: "pie",
            stack: "总量",
            barMaxWidth: 35,
            barGap: "10%",
            emphasis: {
              itemStyle: {
                borderRadius: 0,
                borderColor: "rgba(0, 0, 0, 0)",
                borderWidth: 10,
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: "rgba(0, 0, 0, 0.5)",
              },
            },

            itemStyle: {
              borderRadius: 0,
              borderColor: "#fff",
              borderWidth: 5,
              normal: {
                color: function (params) {
                  var colorList = [
                    {
                      c1: "rgb(13 255 169)", //管理
                      c2: "rgb(13 218 124)",
                    },
                    {
                      c1: "rgba(255, 238, 81,.84)", //实践
                      c2: "rgba(255, 255, 154, .9)",
                    },
                  ];
                  return new echarts.graphic.LinearGradient(1, 0, 0, 0, [
                    {
                      //颜色渐变函数 前四个参数分别表示四个位置依次为左、下、右、上

                      offset: 0,
                      color: colorList[params.dataIndex].c1,
                    },
                    {
                      offset: 1,
                      color: colorList[params.dataIndex].c2,
                    },
                  ]);
                  /*  return colorList[params.dataIndex]*/
                },
              },
            },
            width: "60%",
            left: "center",
            selected: true,
            data: [
              {
                value: 300,
                name: "≥20台",
                label: {
                  formatter: "\n{hr|}{b|{b}}\n{c|{c}}\n{per|{d}%}",
                  lineHeight: 10,
                  minMargin: 5,
                  edgeDistance: 10,
                  rich: {
                    b: {
                      color: "#ffffff",
                      lineHeight: 20,
                      align: "center",
                      verticalAlign: "top",
                    },
                    hr: {
                      backgroundColor: "rgba(13, 255, 169, 1)",
                      width: 1,
                      borderWidth: 1,
                      height: 70,
                      align: "left",
                      verticalAlign: "top",
                    },
                    c: {
                      color: "rgba(13, 255, 169, 1)",
                      lineHeight: 32,
                      align: "left",
                      fontSize: 28,
                      padding: [3, 10],

                      verticalAlign: "middle",
                    },
                    per: {
                      color: "#ffffff",
                      lineHeight: 22,
                      align: "center",

                      verticalAlign: "middle",
                    },
                  },
                },
              },
              {
                value: 1048,
                name: "＜20台",
                selected: true,
                label: {
                  formatter: "{b|{b}}{hr|}\n{c|{c}}\n{per|{d}%}\n",
                  lineHeight: 10,
                  minMargin: 5,
                  edgeDistance: 10,
                  rich: {
                    b: {
                      color: "#ffffff",
                      lineHeight: 20,
                      align: "center",

                      verticalAlign: "top",
                    },
                    hr: {
                      backgroundColor: "rgba(255, 255, 154, 1)",
                      width: 1,
                      borderWidth: 1,
                      height: 70,
                      align: "right",
                      verticalAlign: "top",
                    },
                    c: {
                      color: "#FFFF9A",
                      lineHeight: 32,
                      align: "left",
                      fontSize: 28,
                      padding: [0, 10],
                      verticalAlign: "bottom",
                    },
                    per: {
                      color: "#ffffff",
                      lineHeight: 22,
                      align: "center",
                      verticalAlign: "middle",
                    },
                  },
                },
              },
            ],
          },
        ],
      },
    };
  },
  watch: {
    chartData: {
      deep: true,
      handler(val) {
        this.initChart();
      },
    },
  },
  mounted() {
    this.initChart();
  },
  beforeDestroy() {
    if (!this.chart) {
      return;
    }
    this.chart.dispose();
    this.chart = null;
  },
  methods: {
    setChartData() {
      /*   this.options.xAxis[0].data = this.chartData.regionName;
      this.options.series[0].data = this.chartData.actualProduction; */
      this.chart.setOption(this.options);
    },
    initChart() {
      if (!this.chart) {
        this.chart = echarts.init(document.getElementById(this.id));
      }
      this.setChartData();
    },
  },
};
</script>
